var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"extraClass":"button--fullWidth button--videoProblem","title":_vm.title,"isLink":true,"link":'/' + this.$route.params.slug + '/error-request'}})}
var staticRenderFns = []

export { render, staticRenderFns }